import React, { useState, useEffect } from 'react'
import useUser from '../../hooks/useUser'
import { getPermisosEnPagina, getBasePath, getAuth, getImagenBasePath, toastAlert } from '../../Utils'
import SinPermisos from '../SinPermisos'
import axios from "axios"
import './posteos.scss'
import { Card, CardBody, Button} from 'reactstrap'
import Select from 'react-select'
import { useNavigate, Link  } from 'react-router-dom'
import Swal from 'sweetalert2'
import { JsonToExcel } from "react-json-to-excel"

const Posteos = () => {
    const {isLogged, permisosUsuario, hotelSelected, dataUsuario} = useUser();
    const navigate = useNavigate();
    const permisos = getPermisosEnPagina(permisosUsuario, 'Posteos')
    const [productosHabitaciones, setProductosHabitaciones] = useState([])
    const [productosDefecto, setProductosDefecto] = useState([])
    const [habitaciones, setHabitaciones] = useState([])
    const [inventarioHotel, setInventarioHotel] = useState([])
    const [inventarioEnHabitacion, setInventarioEnHabitacion] = useState([])
    const [productoSelected, setProductoSelected] = useState('')
    const [targetSeleccionado, setTargetSeleccionado] = useState('')
    const [habitacionSelected, setHabitacionSelected] = useState(0)
    const [productos, setProductos] = useState([])
    const [accion, setAccion] = useState('Venta')
    const [reemplazo, setReemplazo] = useState('')
    const [tieneStock, setTieneStock] = useState('')
    const [reemplazoIncidencia, setReemplazoIncidencia] = useState('Reponer con...')
    const [reemplazoTipoIncidencia, setReemplazoTipoIncidencia] = useState('Tipo de incidencia...')
    const [tipos, setTipos] = useState([])

    useEffect(() => {
        if (!isLogged) { navigate("/login"); }
      }, [isLogged]);
 
    const cargarDatosInventario = async () => {
        try {
            const {data: pDefecto} = await axios.get(`${getBasePath()}/productos_defecto/porhotel/${hotelSelected}`, getAuth());
            const {data: inventarioData} = await axios.get(`${getBasePath()}/muestrainventarioenalmacenporhotel/${hotelSelected}`, getAuth()); 
            const {data: inventarioDataHab} = await axios.get(`${getBasePath()}/muestrainventarioenhabitacionporhotel/${hotelSelected}`, getAuth());
            
            setProductosDefecto(pDefecto)
            setInventarioEnHabitacion(inventarioDataHab)
            return inventarioData
        } catch (error) {
            if (sessionStorage.getItem('jwt'))
                Swal.fire({icon: 'error', text: 'Error de carga de inventarios en almacen'})
        }
    }

    const cargarDatosHabitaciones = async () => {
        try {
            const {data: habitacionesData} = await axios.get(`${getBasePath()}/devuelvehabitacionesporhotel/${hotelSelected}`, getAuth());  //table('habitaciones')->where('hotelId',  $id)
            return habitacionesData
        } catch (error) {
            if (sessionStorage.getItem('jwt'))
                Swal.fire({icon: 'error', text: 'Error carga de habitaciones'})
        }
    }

    const cargarDatosProductos = async () => {
        try {
            const {data: dataProductos} = await axios.get(`${getBasePath()}/productos`, getAuth());
            return dataProductos
        } catch (error) {
            if (sessionStorage.getItem('jwt'))
                Swal.fire({icon: 'error', text: 'Error carga de productos'})
        }
    }

    const cargarDatosTipos = async () => {
        try {
            const {data: tipos} = await axios.get(`${getBasePath()}/tipos`, getAuth());
            let tiposOptions = []
            tiposOptions.push({label: 'Tipo de incidencia...'})
            tipos.forEach((valor) => {
                tiposOptions.push({label: valor.nombre, value: valor.nombre})
            })
            return tiposOptions
        } catch (error){
            if (sessionStorage.getItem('jwt'))
                Swal.fire({icon: 'error', text: 'Error carga de tipos'})
        }
    }

    const cargarDatosInventarioHabitacion = () =>  {
        const productosPorHabitaciones = []
        let productosDeHabitacion, productoDentro
        habitaciones.forEach(habitacion => {
                productosDeHabitacion = inventarioEnHabitacion.filter(el => el.habitacionId == habitacion.id)
            if (productosDeHabitacion != undefined) {
                productosPorHabitaciones[habitacion.id] = []
                productosDeHabitacion.forEach(prod => {
                    productosPorHabitaciones[habitacion.id].push(prod)
                })
            }
        })
        productosDefecto.forEach(prodDefecto => {
            prodDefecto.lugar = prodDefecto.situacion
            productosPorHabitaciones.forEach(prodHab => {
                productoDentro = prodHab.find(el => el.productoId == prodDefecto.productoId)
                if(productoDentro == undefined) {
                    productosPorHabitaciones[productosPorHabitaciones.indexOf(prodHab)].push(prodDefecto)
                }
            })
        })
        setProductosHabitaciones(productosPorHabitaciones) 
    }

    const cargarDatos = async () => {
        const datosInventarioAlmacen = await cargarDatosInventario()
        const datosHabitaciones =  await cargarDatosHabitaciones()  
        const dataProductos =  await cargarDatosProductos()  
        const dataTipos = await cargarDatosTipos()

        setProductos(dataProductos)
        setInventarioHotel(datosInventarioAlmacen)
        setHabitaciones(datosHabitaciones)
        setTipos(dataTipos)
    }

    useEffect(() => {
        cargarDatosInventarioHabitacion()
    }, [habitaciones])

    useEffect(() => {
        cargarDatos()
    }, [])

    const getInventariosOption = (producto) => {
        const options = []
        if (inventarioHotel && inventarioHotel.length) {
            const inventarioPorducto = inventarioHotel.filter(el => (el.productoId == producto)) 
            options.push({label: 'Reponer con...', value: '', selected: true})
            if (inventarioPorducto.length) {
                inventarioPorducto.forEach(el => { options.push({label: el.fechaCaducidad, value: el.id }) })
            }
        }
        return options
    }

    const setEstadoHabitacionView = (idH) => {
        const bloque = document.getElementById(`productos-${idH}`)
        const estado = bloque.style.display
        bloque.style.display = estado === 'none' ? 'block' : 'none'
    }

    const getNombreHabitacion = (idHab) => {
        const hab = habitaciones.find(el => el.id == idHab) 
        return hab !== undefined ? hab.nombre : ""
    }

    const getImagenProducto = (idProducto) => {
        const productoImg = productos.find(el => el.id == idProducto)
        if (productoImg != undefined) { return productoImg.imagen }
    }

    const postear = async () => {
        try {
            //
            //************************************************************************************************************************************************* */
            //
            //Control de Errores
            //
            //************************************************************************************************************************************************* */
            //
            //Debemos haber seleccionado un producto
            //
            if (productoSelected == ''){
                Swal.fire({
                    icon: 'warning',
                    text: 'Debe seleccionar un producto'
                })
                return null
            }
            //
            //Debemos haber seleccionado una incidencia
            //
            if (accion == 'I' && (reemplazoTipoIncidencia == '' || reemplazoTipoIncidencia == undefined)) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Tipo de incidencia no indicado'
                })
                return null
            }
            //
            //Si el registro no existe en la habitación no puede crear una incidencia
            //
            const inventarioSelected = inventarioEnHabitacion.find(inv => (inv.productoId == productoSelected && inv.habitacionId == habitacionSelected))
            if ((accion == 'I') && (inventarioSelected == undefined)) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Al no existir el registro en la habitación debe hacer una venta con una fecha de resposición para primero incluirlo'
                })
                return null
            }
            //
            //Si el registro no existe no lo puede vender
            //
            if ((accion != 'I') && (inventarioSelected == undefined) && (reemplazo == '')) {
                Swal.fire({
                    icon: 'warning',
                    text: 'No puede vender un registro que no existe. Seleccione Venta + un producto para reponer + Postear para continuar'
                })
                return null
            }
            //
            //************************************************************************************************************************************************* */
            //
            //Fin del Control de Errores
            //
            //************************************************************************************************************************************************* */
            //
            //Insertamos si existía un registro en la habitación
            //
            let idReemplazo = 'sinReemplazo'
            if(reemplazo.value)
                idReemplazo = reemplazo.value
            if(reemplazoIncidencia.value)
                idReemplazo = reemplazoIncidencia.value
            
            if (inventarioSelected != undefined) {
                inventarioSelected.situacion = accion == 'Venta' ? 'Venta' : reemplazoTipoIncidencia.value
                await axios.get(`${getBasePath()}/actualizaposteo/${inventarioSelected.id}/${hotelSelected}/${idReemplazo}/${inventarioSelected.situacion}/${dataUsuario.id}/${habitacionSelected}`, getAuth())
            }
            //
            //Insertamos si NO EXISTÍA UN REGISTRO EN LA HABITACIÓN
            //
            else{
                await axios.get(`${getBasePath()}/actualizaposteo/0/${hotelSelected}/${idReemplazo}/H/${dataUsuario.id}/${habitacionSelected}`, getAuth())
            }
            document.getElementById(`${habitacionSelected}${productoSelected}`).style.setProperty('display', 'none')
            targetSeleccionado.classList.remove('elementoProducto-inactivo')
            toastAlert('Posteo realizado con éxito')
        } catch (rr) {
            console.error(rr)
        }
    }

    const handleProductoChange = (habitacion, {target}, idProducto) =>  {
        if (!target.classList.contains('seleccionado')) {
            //
            //Ponemos por defecto el valor del desplegable a Reponer con... para que vuelva a seleccionarlo en el nuevo producto
            //
            setReemplazo('Reponer con...')
            setReemplazoIncidencia('Reponer con...')
            setReemplazoTipoIncidencia('Tipo de incidencia...')

            const selected = document.getElementsByClassName('seleccionado')[0]
            if (selected != undefined) {
                selected.classList.remove('seleccionado')
            }
            target.classList.add('seleccionado')
            if(target.className.indexOf('elementoProducto-inactivo') >= 0){
                setTieneStock(false)
                document.getElementsByClassName(`${habitacion}`)[0].innerHTML ="Reponer"
            }
            else{
                setTieneStock(true)
                document.getElementsByClassName(`${habitacion}`)[0].innerHTML ="Venta"
            }
            getInventariosOption(idProducto)
            setProductoSelected(idProducto)
            setHabitacionSelected(habitacion)
            setTargetSeleccionado(target)
        }
    }

    const hayStock = ({target}, producto) => {
        if (producto.productoDefectoId != undefined) {
            target.classList.add('elementoProducto-inactivo')
        }
    }

    const handleAccionChange = ({target}, accionValor, identificador) => {
        let element = document.getElementsByClassName(identificador)

        for (var i = 0; i < element.length; i++) {
            element[i].classList.remove('btn-info');
            element[i].classList.add('btn-secondary')
        }

        target.classList.add('btn-info')

        setAccion(accionValor)
    }

    const obtieneInfoProducto = (productoId) => {
        const datos = productosHabitaciones.find(e => e != undefined).find(e => e.productoId == productoId)
        const producto = productos.find(el => el.id == productoId)
        return [producto.nombre, datos.situacion, datos.fechaCaducidadMostrar]
    }

    function tipoBloque(productos){
        if(productos.find(el => (el.productoDefectoId !== undefined)))
            return 'danger'
        else
            return 'success'
    }
    const tiposPosibles = () => {
        let tiposDevueltos = tipos.filter(tipo => tipo.value !== 'Venta')
        let permisoss = getPermisosEnPagina(permisosUsuario, 'Vuelve al almacén')
        if (permisoss.ver == false)
            return tiposDevueltos.filter(tipo => tipo.value !== 'Vuelve al almacén')
        else
            return tiposDevueltos
    }
    let exceldatos = []
    return isLogged && permisos.ver ? (
        <main>    
            <div style={{display:"none"}}><JsonToExcel data={exceldatos} fileName="Posteos" /></div>
            <h4 className="c-grey-900 mT-10 mB-30">Posteos&nbsp;&nbsp;<Link to='#' style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary" onClick={() => document.getElementsByClassName("download-button")[0].click()}><i className="ti ti-cloud-down"></i></Link></h4>
            {productosHabitaciones.map((productos, index) => {
                const habitacion = productosHabitaciones.indexOf(productos)
                return(
                    <div>
                        <Card className='mb-2 ml-2' style={{ display: 'block' }}>
                            <div className={`d-flex alert alert-${tipoBloque(productos)}`} style={{padding: '10px', display: 'block !important'}}  onClick={() => setEstadoHabitacionView(habitacion)}>
                                    <h6><span style={{ marginRight: '20px'}}>{getNombreHabitacion(habitacion)}</span></h6>
                                        {productos.length && productos.map(el => {
                                            if (el.productoDefectoId !== undefined){
                                                return (
                                                    <div className="mb-2 col-md-2">
                                                        <img 
                                                            id={`${habitacion}${el.productoId}`}
                                                            onLoad={(e) => hayStock(e, el)}
                                                            className='imagenProd' 
                                                            src={`${getImagenBasePath()}/${getImagenProducto(el.productoId)}`}
                                                            style={{maxWidth: '94%'}}
                                                        />
                                                    </div>)
                                            }
                                            })
                                        }
                            </div>
                            <CardBody className='invoice-padding' id={`productos-${habitacion}`} style={{display: 'none'}}>
                                <div className='d-flex mt-2'>
                                    {productos.length && productos.map(el => {
                                        const infoProducto = obtieneInfoProducto(el.productoId)
                                        exceldatos.push({"Habitación": getNombreHabitacion(habitacion), "Producto": infoProducto[0], "Situación": infoProducto[1], "Fecha Caducidad": infoProducto[2]})
                                        return (
                                        <div>
                                            <img 
                                                className='imagenProd' 
                                                onLoad={(e) => hayStock(e, el)}
                                                onClick={(e) => { handleProductoChange(habitacion, e, el.productoId)} } 
                                                src={`${getImagenBasePath()}/${getImagenProducto(el.productoId)}`}
                                                style={{width: '100%'}}
                                            /> 
                                        </div>) 
                                    })}
                                </div>
                                <div className='d-flex mt-2'>
                                    <Button 
                                        className={`btn-accion btn-color ${index}`}
                                        color="info"
                                        onClick={(e) => handleAccionChange(e, 'Venta', `${index}`)}
                                        >Venta</Button>
                                    <Select 
                                        value={reemplazo}
                                        className='desplegable'
                                        options={getInventariosOption(productoSelected)}
                                        onChange={setReemplazo}
                                        id={`opcionesVenta-${index}`}
                                        placeholder='Reponer con...'
                                    />
                                </div>
                                {tieneStock && (<div className='d-flex mt-2'>
                                    <Button 
                                        className={`btn-accion btn-color ${index}`}
                                        color="secondary"
                                        onClick={(e) => handleAccionChange(e, 'I', `${index}`)}
                                        >Incidencia</Button>
                                    <Select 
                                        value={reemplazoIncidencia}
                                        className='desplegable'
                                        options={getInventariosOption(productoSelected)}
                                        onChange={setReemplazoIncidencia}
                                        id={`opcionesIncidencia`}
                                        placeholder='Reponer con...'
                                    />
                                    <Select 
                                        value={reemplazoTipoIncidencia}
                                        className='desplegable'
                                        options={tiposPosibles()}
                                        onChange={setReemplazoTipoIncidencia}
                                        id={`opcionesIncidencia`}
                                        placeholder='Tipo de incidencia...'
                                    />
                                </div>) }
                                <button className="btn btn-primary btn-color mt-2" onClick={() => postear()}>Postear</button>
                            </CardBody>
                        </Card>
                    </div>
                )
            })}
        </main>
    ) : (<SinPermisos/>)
}
export default Posteos